import React, { useEffect, useState, FormEvent } from "react";
import { useDispatch, useSelector } from "react-redux";

import { otpSelector, userSelector } from "selectors/auth.selector";
import { deleteUserSelector } from "selectors/deleteUser.selector";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Typography";

import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

import { PATH_NAME } from "configs";

// actions
import {
  deActivateUserAccount,
  deleteUserAccountPermanent,
} from "actions/deleteAccount.action";

import { sendotp, cancelotp, verifyotp, logout } from "actions/auth.action";
import ImageElement from "components/atoms/ImageElement";
import { fetchEntitiesList } from "actions/employee.action";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { entitiesListSelector } from "selectors/employee.selector";
import OTPInput from "./OTPInput";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import DeleteSuccess from "./DeleteSuccess";

import { useStyles } from "./styles";

const deleteModeList = [
  { id: 0, text: "De-Activate", value: "deActivate" },
  { id: 1, text: "Delete", value: "delete" },
];

export default function AccountDeletion() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [mobile, setMobile] = useState("");
  const [errormessage, setErrormessge] = useState("");
  const [otp, setOtp] = React.useState("");
  const deleteUser = useSelector(deleteUserSelector);
  const otpinfo = useSelector(otpSelector);
  const [entityid, setEntityId] = useState("");
  const userinfo = useSelector(userSelector);
  const entitiesListinfo = useSelector(entitiesListSelector);
  const [deleteMode, setDeleteMode] = useState(deleteModeList[0].value);

  const [isOtpOpen, setIsOtpOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const _onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!otpinfo.isotpreceived && !otpinfo.isotpverified) {
      if (entityid && mobile) {
        dispatch(sendotp(mobile, entityid));
        setIsOtpOpen(true);
      }
    } else {
      dispatch(
        verifyotp(
          otp,
          mobile,
          userinfo.id,
          userinfo.verifytoken,
          true, // OTP flow
          false,
          false
        )
      );
    }
  };

  useEffect(() => {
    dispatch(fetchEntitiesList());
    // we are trying to clear login as well
    dispatch(logout());
  }, []);

  useEffect(() => {
    if (otpinfo.otperrormessage) {
      setErrormessge(otpinfo.otperrormessage);
    }

    if (otpinfo.isotpreceived && otpinfo.isotpverified) {
      setIsConfirmationOpen(true);
    }
  }, [otpinfo, otpinfo.isotpverified]);

  const onResendOtp = () => {
    dispatch(cancelotp());
    setOtp("");
    dispatch(logout());

    if (entityid && mobile) {
      dispatch(sendotp(mobile, entityid));
    }
  };

  const onOtpTimerOut = () => {
    dispatch(cancelotp());
    setOtp("");
    dispatch(logout());
  };

  const handelOnCancelConfirmationModal = () => {
    setIsConfirmationOpen(false);
    dispatch(logout());
    dispatch(cancelotp());
    setIsOtpOpen(false);
    setOtp("");
  };

  const handleOnClickProceedToDeleteAccount = () => {
    setIsConfirmationOpen(false);

    // if user delelte mode is  permanent delete
    if (deleteMode === deleteModeList[1].value) {
      dispatch(deleteUserAccountPermanent(userinfo?.id));
    } else {
      dispatch(deActivateUserAccount(userinfo?.id));
    }
  };

  useEffect(() => {
    // logging out  as well
    if (deleteUser?.userDeleted) {
      dispatch(logout());
    }
  }, [deleteUser]);

  const handleotpChange = (newValue: string) => {
    setOtp(newValue);
  };

  const renderFormSection = () => {
    return (
      <div className={classes.paper} style={{ alignItems: "baseline" }}>
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <ImageElement
            src="/assets/images/logo.png"
            style={{
              height: "90%",
              width: "10%",
              paddingRight: "2%",
              textAlign: "center",
            }}
          />
          <Typography
            component="h1"
            variant="h5"
            style={{
              textAlign: "center",
              fontSize: "1.5vw",
            }}
          >
            {" "}
            AMT{" "}
          </Typography>
        </Box>

        <Box className={classes.formContainer}>
          <>
            <Typography
              gutterBottom
              component="h1"
              variant="h4"
              style={{
                color: "#16151C",
                fontWeight: 400,

                marginBottom: "20px",
              }}
            >
              Would you like to delete or deactivate your account?
            </Typography>
          </>

          <form className={classes.form} noValidate onSubmit={_onSubmit}>
            <>
              <FormControl
                style={{
                  margin: "10px !important",
                  marginLeft: "0px !important",
                  width: "100%",
                  marginBottom: "15px",
                }}
              >
                <InputLabel id="delete-type-select-label">Type</InputLabel>
                <Select
                  id="delete-select"
                  color="primary"
                  onChange={(e) => setDeleteMode(e.target.value)}
                  value={deleteMode}
                  label="Type"
                  sx={{
                    borderRadius: "10px",
                  }}
                >
                  {deleteModeList?.map((eachDeleteMode, index) => (
                    <MenuItem key={index} value={eachDeleteMode?.value}>
                      {eachDeleteMode?.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl
                style={{
                  margin: "10px !important",
                  marginLeft: "0px !important",
                  width: "100%",
                  marginBottom: "15px",
                }}
              >
                <InputLabel id="entity-select-label">Entity</InputLabel>
                <Select
                  id="Entity-select"
                  color="primary"
                  value={entityid}
                  onChange={(e) => {
                    setEntityId(e.target.value);
                  }}
                  label="Entity"
                  sx={{
                    borderRadius: "10px",
                  }}
                >
                  {entitiesListinfo?.map((d: any) => (
                    <MenuItem value={d.entity_id}>{d.entity_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                variant="filled"
                margin="normal"
                fullWidth
                id="mobile"
                label="Enter Mobile Number"
                name="mobile"
                autoComplete="mobile"
                value={mobile}
                onChange={(e) => {
                  setMobile(e.target.value);
                  if (errormessage) {
                    setErrormessge("");
                  }
                }}
                style={{
                  margin: "0px",
                  marginBottom: "15px",
                }}
              />

              {isOtpOpen && (
                <OTPInput
                  otp={otp}
                  handleotpChange={handleotpChange}
                  onResendOtp={onResendOtp}
                  onOtpTimerOut={onOtpTimerOut}
                />
              )}
            </>

            <Typography
              variant="body1"
              color="error"
              display="block"
              gutterBottom
              style={{ fontSize: "1.2vw" }}
            >
              {errormessage}
            </Typography>

            {otpinfo?.isotpreceived && !otpinfo?.isotpverified ? (
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                style={{
                  height: 56,
                  borderRadius: 10,
                  marginBottom: 0,
                  opacity: mobile && entityid && otp.length === 6 ? 1 : 0.5,
                }}
              >
                Verify
              </Button>
            ) : (
              <>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  style={{
                    opacity: mobile && entityid ? 1 : 0.5,
                    height: 56,
                    borderRadius: 10,
                    marginBottom: 0,
                  }}
                >
                  Send OTP
                </Button>
              </>
            )}
          </form>
        </Box>

        <Typography
          variant="h5"
          style={{ textAlign: "center", margin: "10px 0px", width: "100%" }}
        >
          <a
            target="_blank"
            href={PATH_NAME.LOGIN}
            style={{
              color: "#7152F3",
              textDecoration: "underline",
              textUnderlineOffset: 5,
              fontWeight: 700,
            }}
          >
            Back to Login page
          </a>
        </Typography>
      </div>
    );
  };

  const renderViewsBasedOnStatus = () => {
    switch (deleteUser?.userDeleted) {
      case true:
        return (
          <DeleteSuccess
            mobile={mobile}
            deleteModeText={
              deleteMode === deleteModeList[0].value ? "deactivated" : "deleted"
            }
          />
        );

      case false:
        return renderFormSection();

      default:
        return null;
    }
  };

  return (
    <Box className={classes.root}>
      {renderViewsBasedOnStatus()}

      {/* <DeleteSuccess 
        mobile={mobile}
        deleteModeText={deleteMode === deleteModeList[0].value ? "deactivated" : "deleted"}
        />  */}

      {isConfirmationOpen && (
        <DeleteConfirmationModal
          handleOnClickProceedToDeleteAccount={
            handleOnClickProceedToDeleteAccount
          }
          handelOnCancelConfirmationModal={handelOnCancelConfirmationModal}
        />
      )}
    </Box>
  );
}
